<template>
  <div class="wp_img">
    <img :src="img">
  </div>
</template>

<script>
export default {
name: "YinDao",
  data() {
    return {
      img: require('../assets/2.jpg')
    }
  }
}
</script>

<style scoped lang="less">

</style>